export const state = {
  token: null,
  user: {},
  conversations: {},
  messages: [],
  activeClientId: '',
  conversationStates: {},
};
